export var Icon = {
    /* eslint-disable @typescript-eslint/no-empty-function */
    install: function () { }
};
export default Icon;
